import { type Move } from './models/move.model'
import { type MoveJob } from './models/subModels/moveJob.model'
import { type MoveLocations } from './models/subModels/moveLocations.models'

export const getUsedLocations = (move: Move) => {
  const jobsIds = move.jobs
    .map(job => job.resolved?.timeline?.actions?.map(action => action.locationId) ?? [])
    ?.flat()
    ?.filter(l => !!l) as string[]
  return Array.from(new Set(jobsIds))
    .map(id => getLocationById(move.locations, id))
    .filter(l => !!l)
}

const getAllLocations = (locations: MoveLocations) => {
  return [
    locations.origin,
    locations.destination,
    ...(locations.stops ?? []),
    locations.warehouse,
  ].filter((location) => !!location)
}

export const getLocationById = (
  locations: MoveLocations,
  id: string,
) => {
  const customerLocations = getAllLocations(locations)
  return customerLocations.find((location) => location.id === id)
}

export const getFirstJobLocation = (
  job: Pick<MoveJob, 'resolved'>,
  locations: MoveLocations,
) => {
  const firstLocationId = job.resolved?.timeline?.actions?.find(
    (action) => !!action.locationId,
  )?.locationId
  return firstLocationId ? getLocationById(locations, firstLocationId) : undefined
}

export const getLastJobLocation = (
  job: Pick<MoveJob, 'resolved'>,
  locations: MoveLocations,
) => {
  const lastLocationId = [...job.resolved?.timeline?.actions ?? []]
    .reverse()
    .find((action) => !!action.locationId)?.locationId
  return lastLocationId ? getLocationById(locations, lastLocationId) : undefined
}

export const getMoveReferenceLocations = (move: Move) => {
  return {
    origin:
      move.locations.origin ??
      getFirstJobLocation(move.jobs[0], move.locations),
    destination:
      move.locations.destination ??
      getLastJobLocation(move.jobs[move.jobs.length - 1], move.locations),
  }
}
